// extracted by mini-css-extract-plugin
export default {"name":"useColumns_name__9vHEt","link":"useColumns_link__6knTB"};